export const countriesSelector = (state) => state.organizationList.countries;
export const isLoadingSelector = (state) => state.organizationList.loading;
export const isLoadingModulesSelector = (state) => state.organizationList.loadingCompanyModules;
export const isShowSnackbar = (state) => state.organizationList.snackbarShow;
export const snackbarType = (state) => state.organizationList.snackbarType;
export const snackbarText = (state) => state.organizationList.snackbarText;
export const companiesSelector = (state) => state.organizationList.companies;
export const statsSelector = (state) => state.organizationList.stats;
export const modulesSelector = (state) => state.organizationList.companyModules;
